import {Button} from '../../../../../../../../../ui/atoms/button';
import {Body2} from '../../../../../../../../../ui/atoms/typography';
import {ItemLoader} from '../../../../../../../../../ui/organisms/item-loader';
import {parseCurrencyValue} from '@constants';
import {useBillingHook} from '../../../admin-billing.hooks';
import {IBillingPlan} from '../../../admin-billing.interface';
import {PlanDiv, PlansDiv} from '../billing-not-active.styles';

interface IBillingPlansComponent {
  loader: boolean;
  plans: IBillingPlan[];
  billingCycle: 'lifetime' | 'monthly';
}
export const BillingPlans = ({
  loader,
  plans,
  billingCycle,
}: IBillingPlansComponent) => {
  const {chooseBillingPlan} = useBillingHook();
  const formatPrice = (currency: string | undefined, value?: number) =>
    typeof value === 'number'
      ? `${parseCurrencyValue(currency || 'USD')}${value}`
      : '—';

  return (
    <PlansDiv>
      {!loader &&
        // eslint-disable-next-line array-callback-return
        plans.map((plan: IBillingPlan) => {
          if (plan.isVisible) {
            return (
              <PlanDiv key={plan.plan}>
                <div>
                  <div className="pricingOptions">
                    <div className="pricingOption">
                      <div className="pricingLabel">
                        <Body2 kind="textDark" weight="semibold">
                          Pay monthly
                        </Body2>
                      </div>
                      <div className="priceLine">
                        <span className="price">
                          {formatPrice(plan.currency, plan.monthly.unitCost)}
                        </span>
                        <span className="priceUnit">per user / month</span>
                      </div>
                      <Body2 kind="textBody">Billed every month</Body2>
                    </div>

                    <div className="pricingOption">
                      <div className="pricingLabel">
                        <Body2 kind="textDark" weight="semibold">
                          Pay annually
                        </Body2>
                        {!!plan.yearly.yearlyDiscountPercent && (
                          <span className="savingsBadge">
                            Save {plan.yearly.yearlyDiscountPercent}%
                          </span>
                        )}
                      </div>
                      <div className="priceLine">
                        <span className="price">
                          {formatPrice(plan.currency, plan.yearly.unitCost)}
                        </span>
                        <span className="priceUnit">per user / month</span>
                      </div>
                      <Body2 kind="textBody">Billed once a year</Body2>
                    </div>
                  </div>
                </div>

                <div className="planActions">
                  <Button
                    width="full"
                    onClick={chooseBillingPlan(plan.plan, billingCycle)}>
                    Continue
                  </Button>
                  <Body2 kind="textBody" className="nextStep">
                    Next, choose your seats and billing cycle.
                  </Body2>
                </div>
              </PlanDiv>
            );
          }
        })}
      {loader && <ItemLoader />}
    </PlansDiv>
  );
};
